export default "__VITE_ASSET__BxOus431__"